import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // status: 'loading' | 'authenticated' | 'guest'
  const [status, setStatus] = useState(getToken() ? "loading" : "guest");
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setStatus("authenticated");
      return data;
    } catch (_e) {
      clearToken();
      setUser(null);
      setStatus("guest");
      return null;
    }
  }, []);

  useEffect(() => {
    if (getToken()) loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    setStatus("authenticated");
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_e) {
      /* ignore */
    }
    clearToken();
    setUser(null);
    setStatus("guest");
  };

  return (
    <AuthContext.Provider value={{ status, user, login, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
